/* electro-interactive.js */
(function () {
  'use strict';

  /* ── Ingredient data ─────────────────────────────────────────────────── */
  var INGREDIENTS = [
    {
      name: 'Potassium',
      img: 'ingredients-potassium.webp',
      does: 'The electrolyte your muscles burn through fastest when you sweat. It keeps signals firing so you don\'t cramp up mid-game, and it works with sodium to pull fluid where your body actually needs it.',
      why: 'Most drinks pile on sugar and barely add potassium. We dose it at the level athletes lose, no sugar needed to carry it.'
    },
    {
      name: 'Magnesium',
      img: 'ingredients-magnesium.webp',
      does: 'Controls hundreds of reactions in your body including muscle contraction, nerve transmission, and energy production. Low magnesium is a leading cause of mid-exercise cramping that isn\'t fixed by just drinking more water.',
      why: 'Athletes are 10–20% more likely to be magnesium-deficient. We use a highly bioavailable form so it absorbs fast and actually reaches your muscles when it counts.'
    },
    {
      name: 'Sodium',
      img: 'ingredients-sodium.webp',
      does: 'Your body\'s master fluid regulator. Sodium controls how much water your cells hold, drives thirst signals, and lets your muscles contract. It\'s the first electrolyte you lose in sweat and the one that matters most for absorption.',
      why: 'Without sodium, water just passes through. We include the right amount to trigger real absorption and replace what sweat takes — without overloading you with salt you don\'t need.'
    }
  ];

  var ingredientIndex = 0;

  /* ── Tab review data (from original Vercel build) ────────────────────── */
  var TAB_REVIEWS = {
    'Taste': [
      { quote: 'Tropical splash actually slaps. First piece you get bright orange, then this mango note hits on the back end. Tastes like a real drink, not a vitamin.', name: 'Marcus T.', sport: 'Lacrosse, UNC' },
      { quote: 'Honestly did not think a gum could pull off a real tropical flavor without going syrupy. First piece you get the orange, then there is this mango thing that hits on the back end. It tastes like an actual drink, not a vitamin.', name: 'Sophia L.', sport: 'College Student' },
      { quote: 'I was scared it would taste like chalk because every electrolyte product I have tried tastes like punishment. Pop one before practice and the flavor lasts a full mile.', name: 'Devon R.', sport: 'Cross Country' }
    ],
    'Value': [
      { quote: 'I run the numbers on this stuff because I am a broke college kid. Used to drop $25 a week on bottles and powders. Switched to the 90 day plan, came out to under a dollar a day, and my drawer is not filled with empty plastic anymore.', name: 'Tyler M.', sport: 'CrossFit' },
      { quote: 'Math is real. One piece replaces a $5 LMNT packet, and I am cancelling my LMNT subscription this month.', name: 'Emma R.', sport: 'Tennis' },
      { quote: 'A $4 Gatorade is gone in 60 seconds. A pouch of Electro covers me for two weeks.', name: 'Jamal K.', sport: 'Football' }
    ],
    'vs Powder': [
      { quote: 'I had a whole drawer of powder packets. Liquid IV, LMNT, Pedialyte, you name it. They all need a bottle, water, and a vibe to actually mix them. Electro is just a piece of gum. I have not opened that drawer in two months.', name: 'Rachel P.', sport: 'Field Hockey' },
      { quote: 'Used LMNT for a year. Mixing 4 packets a day got old. Electro lives in my pocket, done.', name: 'Anna B.', sport: 'Marathon' },
      { quote: 'Liquid IV bloats me 20 minutes in. Electro hits faster, no shaker, no chalk. Tossed the powder stash.', name: 'Carlos D.', sport: 'Soccer' }
    ],
    'Benefits': [
      { quote: 'I was cramping every 4th quarter, every game. Coach kept telling me to drink more water and it was not doing anything. Started taking two pieces before tip-off and one at half. Three months in, zero cramps. I am not selling anything, this is just what happened.', name: 'DeShawn W.', sport: 'Basketball' },
      { quote: 'First piece I chewed I felt it kick in. Way faster than chugging anything.', name: 'Tony S.', sport: 'Track' },
      { quote: 'Felt sharper through 2-a-days. No afternoon dip and no chasing a second wind, just pop one between sessions and lock back in.', name: 'Megan H.', sport: 'Swim' }
    ],
    'Convenience': [
      { quote: 'I travel for work and TSA hates liquids. I used to land already dehydrated, then have to hunt for a sports drink in some random airport. Now I throw a pouch in my carry-on and chew two on the plane. Way easier.', name: 'Lila K.', sport: 'Field Sales' },
      { quote: 'Plane, gym, halftime, study session. Works everywhere. Nothing else does.', name: 'Maya V.', sport: 'Pole Vault' },
      { quote: 'Hit a wall at 2pm? Pop one. No mixing, no shaker, no excuses. My athletes asked what I was chewing, now half the team does it too.', name: 'Brendan T.', sport: 'Track Coach' }
    ]
  };

  var STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star fill-yellow-400 text-yellow-400" aria-hidden="true"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>';

  /* ── Central click handler ────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    handleVideo(e);
    handlePlanSelector(e);
    handleReviewCarousel(e);
    handleShowIngredient(e);
    handleNavIngredient(e);
    handleAccordion(e);
    handleTabs(e);
  });

  /* ── 1. Fan video click-to-play ──────────────────────────────────────── */
  function handleVideo(e) {
    var btn = e.target.closest('button[aria-label="Play clip"], button[aria-label="Pause clip"]');
    if (!btn) return;
    var video = btn.querySelector('video');
    if (!video) return;
    var overlay = btn.querySelector('span.absolute');

    if (video.paused) {
      document.querySelectorAll('button[aria-label="Play clip"] video, button[aria-label="Pause clip"] video').forEach(function (v) {
        if (v === video) return;
        v.pause();
        v.currentTime = 0;
        var ob = v.closest('button');
        if (ob) {
          ob.setAttribute('aria-label', 'Play clip');
          var ov = ob.querySelector('span.absolute');
          if (ov) ov.style.display = '';
        }
      });
      video.play();
      btn.setAttribute('aria-label', 'Pause clip');
      if (overlay) overlay.style.display = 'none';
    } else {
      video.pause();
      btn.setAttribute('aria-label', 'Play clip');
      if (overlay) overlay.style.display = '';
    }
  }

  document.addEventListener('ended', function (e) {
    if (!e.target || e.target.tagName !== 'VIDEO') return;
    var btn = e.target.closest('button');
    if (!btn) return;
    btn.setAttribute('aria-label', 'Play clip');
    var overlay = btn.querySelector('span.absolute');
    if (overlay) overlay.style.display = '';
  }, true);

  /* ── 2. Plan selector ────────────────────────────────────────────────── */
  function handlePlanSelector(e) {
    var btn = e.target.closest('button[aria-pressed]');
    if (!btn) return;
    if (btn.getAttribute('role') === 'tab') return;

    var section = btn.closest('section') || document.body;
    var allBtns = section.querySelectorAll('button[aria-pressed]');

    allBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      var lbl = b.getAttribute('aria-label') || '';
      if (lbl.indexOf('Select') === 0) {
        b.classList.remove('border-electro-orange', 'bg-electro-cream');
        b.classList.add('border-gray-200', 'bg-white');
        var radio = b.querySelector('.w-5.h-5.rounded-full.border-2');
        if (radio) {
          radio.classList.remove('border-electro-orange');
          radio.classList.add('border-gray-300');
          var dot = radio.querySelector('.bg-electro-orange');
          if (dot) dot.remove();
        }
      }
    });

    btn.setAttribute('aria-pressed', 'true');
    var label = btn.getAttribute('aria-label') || '';
    if (label.indexOf('Select') === 0) {
      btn.classList.add('border-electro-orange', 'bg-electro-cream');
      btn.classList.remove('border-gray-200', 'bg-white');
      var radio = btn.querySelector('.w-5.h-5.rounded-full.border-2');
      if (radio) {
        radio.classList.add('border-electro-orange');
        radio.classList.remove('border-gray-300');
        if (!radio.querySelector('.bg-electro-orange')) {
          var dot = document.createElement('span');
          dot.className = 'w-2.5 h-2.5 rounded-full bg-electro-orange';
          radio.appendChild(dot);
        }
      }
    }

    var qty = btn.getAttribute('data-quantity');
    var planId = btn.getAttribute('data-selling-plan') || '';
    var variantId = btn.getAttribute('data-variant') || '';
    var isOnetime = btn.hasAttribute('data-selling-plan') && planId === '';
    var form = section.querySelector('form[action="/cart/add"]');
    if (form && qty) {
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var planInput = form.querySelector('input[name="selling_plan"]');
      if (idInput && variantId) idInput.value = variantId;
      if (qtyInput) qtyInput.value = qty;
      if (planInput) {
        planInput.value = planId;
        planInput.disabled = isOnetime;
      }
      if (isOnetime) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  }

  /* ── 3. Mobile nav menu ──────────────────────────────────────────────── */
  function initMobileMenu() {
    var btn = document.querySelector('button[aria-label="Open menu"]');
    var nav = document.querySelector('nav[aria-label="Primary"]');
    if (!btn || !nav) return;

    var overlay = document.createElement('div');
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:39';
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.style.cssText = 'display:none;position:fixed;top:0;right:0;bottom:0;width:260px;background:#fff;z-index:41;padding:24px 20px;flex-direction:column;gap:20px;box-shadow:-4px 0 24px rgba(0,0,0,0.12)';

    var links = nav.cloneNode(true);
    links.style.cssText = 'display:flex!important;flex-direction:column;gap:20px;font-size:18px;';

    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.style.cssText = 'align-self:flex-end;background:none;border:none;font-size:28px;cursor:pointer;color:#0A0A0A;line-height:1;margin-bottom:8px';

    drawer.appendChild(closeBtn);
    drawer.appendChild(links);
    document.body.appendChild(drawer);

    function openMenu() {
      overlay.style.display = 'block';
      drawer.style.display = 'flex';
      btn.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      overlay.style.display = 'none';
      drawer.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
    }
    btn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
  }

  /* ── 4. Review carousel — infinite loop ─────────────────────────────── */
  function handleReviewCarousel(e) {
    var btn = e.target.closest('button[aria-label="Previous reviews"], button[aria-label="Next reviews"]');
    if (!btn) return;
    var container = btn.parentElement;
    var scroller = container && container.querySelector('div.overflow-x-auto');
    if (!scroller) return;
    var dir = btn.getAttribute('aria-label') === 'Next reviews' ? 1 : -1;
    var max = scroller.scrollWidth - scroller.clientWidth;
    var cur = Math.round(scroller.scrollLeft);
    if (dir === 1 && cur >= max - 5) {
      scroller.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (dir === -1 && cur <= 5) {
      scroller.scrollTo({ left: max, behavior: 'smooth' });
    } else {
      scroller.scrollBy({ left: dir * scroller.clientWidth * 0.85, behavior: 'smooth' });
    }
  }

  /* ── 5. Ingredient slider — show by name ─────────────────────────────── */
  function handleShowIngredient(e) {
    var btn = e.target.closest('button[aria-label^="Show "]');
    if (!btn) return;
    var name = btn.getAttribute('aria-label').replace('Show ', '');
    var idx = INGREDIENTS.findIndex(function (item) { return item.name === name; });
    if (idx < 0) return;
    var section = btn.closest('section');
    if (!section) return;
    updateIngredient(section, idx);
  }

  /* ── 6. Ingredient slider — prev/next ────────────────────────────────── */
  function handleNavIngredient(e) {
    var prev = e.target.closest('button[aria-label="Previous ingredient"]');
    var next = e.target.closest('button[aria-label="Next ingredient"]');
    if (!prev && !next) return;
    var section = (prev || next).closest('section');
    if (!section) return;
    var dir = next ? 1 : -1;
    var newIdx = (ingredientIndex + INGREDIENTS.length + dir) % INGREDIENTS.length;
    updateIngredient(section, newIdx);
  }

  function updateIngredient(section, idx) {
    ingredientIndex = idx;
    var item = INGREDIENTS[idx];
    var prevIdx = (idx + INGREDIENTS.length - 1) % INGREDIENTS.length;
    var nextIdx = (idx + 1) % INGREDIENTS.length;

    var h3 = section.querySelector('h3.font-display');
    if (h3) h3.textContent = item.name;

    var centerImg = section.querySelector('.z-10 img');
    if (centerImg) {
      centerImg.alt = item.name;
      centerImg.src = swapIngredientSrc(centerImg.src, item.img);
    }

    var leftBtn = section.querySelector('button[style*="left:calc"]');
    if (leftBtn) {
      leftBtn.setAttribute('aria-label', 'Show ' + INGREDIENTS[prevIdx].name);
      var leftImg = leftBtn.querySelector('img');
      if (leftImg) {
        leftImg.alt = INGREDIENTS[prevIdx].name;
        leftImg.src = swapIngredientSrc(leftImg.src, INGREDIENTS[prevIdx].img);
      }
    }

    var rightBtn = section.querySelector('button[style*="right:calc"]');
    if (rightBtn) {
      rightBtn.setAttribute('aria-label', 'Show ' + INGREDIENTS[nextIdx].name);
      var rightImg = rightBtn.querySelector('img');
      if (rightImg) {
        rightImg.alt = INGREDIENTS[nextIdx].name;
        rightImg.src = swapIngredientSrc(rightImg.src, INGREDIENTS[nextIdx].img);
      }
    }

    var descEl = section.querySelector('div.border-t.border-gray-200');
    if (descEl) {
      var paras = descEl.querySelectorAll('p');
      if (paras[0]) paras[0].textContent = item.does;
      if (paras[1]) paras[1].textContent = item.why;
    }

    var dotWrap = section.querySelector('div.flex.justify-center.gap-2');
    if (dotWrap) {
      dotWrap.querySelectorAll('button').forEach(function (dot) {
        var dname = (dot.getAttribute('aria-label') || '').replace('Show ', '');
        var active = dname === item.name;
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
        var span = dot.querySelector('span');
        if (span) {
          if (active) {
            span.classList.remove('bg-gray-300', 'w-2');
            span.classList.add('bg-electro-blue', 'w-6');
          } else {
            span.classList.remove('bg-electro-blue', 'w-6');
            span.classList.add('bg-gray-300', 'w-2');
          }
        }
      });
    }
  }

  function swapIngredientSrc(src, newFilename) {
    return src.replace(/ingredients-\w+\.webp(\?.*)?$/, newFilename);
  }

  /* ── 7. Accordions — single-open ─────────────────────────────────────── */
  function getAccordionGroup(btn) {
    var el = btn.parentElement;
    while (el && el !== document.body) {
      if (el.querySelectorAll('button[aria-controls]').length > 1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function setAccordionIcon(svg, opening) {
    if (!svg) return;
    if (opening) {
      svg.classList.replace('lucide-plus', 'lucide-minus');
      var paths = svg.querySelectorAll('path');
      if (paths.length > 1) paths[paths.length - 1].remove();
    } else {
      svg.classList.replace('lucide-minus', 'lucide-plus');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M12 5v14');
      svg.appendChild(p);
    }
  }

  function handleAccordion(e) {
    var btn = e.target.closest('button[aria-controls]');
    if (!btn) return;
    if (btn.getAttribute('role') === 'tab') return;

    var panelId = btn.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;

    var wasExpanded = btn.getAttribute('aria-expanded') === 'true';
    var nowExpanded = !wasExpanded;

    // Close open siblings (single-open per group)
    var group = getAccordionGroup(btn);
    if (group) {
      group.querySelectorAll('button[aria-controls]').forEach(function (sib) {
        if (sib === btn) return;
        if (sib.getAttribute('aria-expanded') !== 'true') return;
        sib.setAttribute('aria-expanded', 'false');
        var sibPanel = document.getElementById(sib.getAttribute('aria-controls'));
        if (sibPanel) sibPanel.style.display = 'none';
        setAccordionIcon(sib.querySelector('svg.lucide-minus, svg.lucide-plus'), false);
      });
    }

    // Toggle clicked item
    btn.setAttribute('aria-expanded', String(nowExpanded));
    panel.style.display = nowExpanded ? '' : 'none';
    setAccordionIcon(btn.querySelector('svg.lucide-minus, svg.lucide-plus'), nowExpanded);

    // Benefit side panel highlight when opening
    if (panelId.indexOf('benefit-panel-') === 0 && nowExpanded) {
      highlightBenefitRow(parseInt(panelId.replace('benefit-panel-', ''), 10));
    }
  }

  function highlightBenefitRow(activeIdx) {
    var anyBtn = document.querySelector('button[aria-controls^="benefit-panel-"]');
    if (!anyBtn) return;
    // Walk up to find the column that holds all benefit buttons
    var col = anyBtn.parentElement;
    while (col && col.querySelectorAll('button[aria-controls^="benefit-panel-"]').length < 2) {
      col = col.parentElement;
    }
    if (!col) return;
    var grid = col.parentElement;
    if (!grid) return;
    // Side card is the other grid child with a UL
    var sideCard = null;
    Array.from(grid.children).forEach(function (child) {
      if (child !== col && child.querySelector && child.querySelector('ul')) sideCard = child;
    });
    if (!sideCard) return;

    sideCard.querySelectorAll('li').forEach(function (li, i) {
      var bar = li.querySelector('[class*="bg-electro-blue"]');
      if (i === activeIdx) {
        li.style.background = 'rgba(26,95,255,0.05)';
        li.style.borderRadius = '8px';
        li.style.padding = '4px 6px';
        if (bar) bar.style.background = '#F47020';
      } else {
        li.style.background = '';
        li.style.borderRadius = '';
        li.style.padding = '';
        if (bar) bar.style.background = '';
      }
    });
  }

  /* ── 8. Review / topic tabs — card swap ─────────────────────────────── */
  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function buildReviewCard(r) {
    var stars = STAR_SVG.repeat(5);
    return '<article class="bg-white rounded-2xl p-6 shadow-sm flex flex-col shrink-0 snap-start basis-[80%] sm:basis-[60%] md:basis-auto">' +
      '<div class="flex items-center gap-0.5" aria-label="5 out of 5 stars">' + stars + '</div>' +
      '<p class="mt-3 font-body text-gray-700 text-sm leading-relaxed flex-1">' + escapeHtml(r.quote) + '</p>' +
      '<div class="mt-4 pt-4 border-t border-gray-100">' +
        '<p class="font-bold text-sm text-electro-ink">' + escapeHtml(r.name) + '</p>' +
        '<p class="text-[11px] text-gray-500 mt-0.5">' + escapeHtml(r.sport) + '</p>' +
      '</div></article>';
  }

  function handleTabs(e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    var tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;

    var label = tab.textContent.trim();
    var normalized = label.replace(/\./g, '');

    // Update all tab buttons (mobile + desktop sets both live inside tablist)
    tablist.querySelectorAll('[role="tab"]').forEach(function (t) {
      var tNorm = t.textContent.trim().replace(/\./g, '');
      var active = tNorm === normalized;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) {
        t.classList.add('bg-white', 'text-electro-blue');
        t.classList.remove('bg-electro-orange', 'text-white');
      } else {
        t.classList.add('bg-electro-orange', 'text-white');
        t.classList.remove('bg-white', 'text-electro-blue');
      }
    });

    var reviews = TAB_REVIEWS[label] || TAB_REVIEWS[normalized];
    if (!reviews) return;

    // Review grid is the first sibling of tablist inside its parent container
    var container = tablist.parentElement;
    var grid = null;
    var seenTablist = false;
    for (var i = 0; i < container.children.length; i++) {
      var child = container.children[i];
      if (child === tablist) { seenTablist = true; continue; }
      if (seenTablist && !grid) { grid = child; break; }
    }
    if (!grid) return;
    grid.innerHTML = reviews.map(buildReviewCard).join('');
  }

  /* ── 9. Marquee — JS-driven for all .marquee-track ───────────────────── */
  function initMarquee() {
    document.querySelectorAll('.marquee-track').forEach(function (track) {
      // Disable CSS animation so JS controls transforms exclusively
      track.style.setProperty('animation', 'none', 'important');

      var durationStr = track.style.animationDuration || '35s';
      var duration = parseFloat(durationStr) || 35;

      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.style.setProperty('animation', 'none', 'important');
      track.parentNode.insertBefore(clone, track.nextSibling);

      var w = 0;
      var pos = 0;
      var speed = 0;

      function measure() {
        w = track.offsetWidth || track.scrollWidth;
        speed = w > 0 ? w / (duration * 60) : 0.5;
      }

      measure();
      // Re-measure after fonts/images load in case width changed
      window.addEventListener('load', measure, { once: true });

      (function tick() {
        if (w > 0) {
          pos -= speed;
          if (pos <= -w) pos = 0;
          track.style.transform = 'translateX(' + pos + 'px)';
          clone.style.transform = 'translateX(' + (pos + w) + 'px)';
        }
        requestAnimationFrame(tick);
      })();
    });
  }

  /* ── 10. Science count-up animation ─────────────────────────────────── */
  function initCountUp() {
    var CIRC = 2 * Math.PI * 42; // SVG circle circumference

    function countUp(span, target, duration) {
      var start = performance.now();
      (function tick(now) {
        var p = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        span.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(tick);
        else span.textContent = target;
      })(performance.now());
    }

    function observeOnce(el, threshold, cb) {
      if (!el || !window.IntersectionObserver) { cb(); return; }
      var fired = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fired) {
            fired = true;
            obs.disconnect();
            cb();
          }
        });
      }, { threshold: threshold || 0.3 });
      obs.observe(el);
    }

    // Main stats: "The research speaks for itself"
    var statsSection = null;
    document.querySelectorAll('h2').forEach(function (h) {
      if (h.textContent.toLowerCase().indexOf('speaks for itself') >= 0) {
        statsSection = h.closest('section') || h.parentElement;
      }
    });

    if (statsSection) {
      var statValues = [3, 2, 30, 3];
      var statInnerSpans = [];
      statsSection.querySelectorAll('span[style*="F47020"]').forEach(function (el) {
        // Only the big display-font number spans (text-6xl), not the people-report ones
        if (el.className && el.className.indexOf('text-6xl') >= 0) {
          var inner = el.querySelector('span');
          if (inner) statInnerSpans.push(inner);
        }
      });

      observeOnce(statsSection, 0.3, function () {
        statInnerSpans.forEach(function (span, i) {
          if (statValues[i] !== undefined) countUp(span, statValues[i], 1200);
        });
      });
    }

    // "What people report" circles
    var reportCircles = Array.from(document.querySelectorAll('circle[stroke-dashoffset]'));
    var reportValues = [94, 89, 87, 92];
    var reportSpans = [];

    reportCircles.forEach(function (circle) {
      var wrapper = circle.closest('[style*="width:144px"]') || circle.closest('.relative');
      if (wrapper) {
        var sp = wrapper.querySelector('.absolute span');
        if (sp) reportSpans.push(sp);
      }
    });

    if (reportCircles.length > 0) {
      var reportSection = reportCircles[0].closest('section') || reportCircles[0].parentElement;
      observeOnce(reportSection, 0.3, function () {
        reportCircles.forEach(function (circle, i) {
          var pct = reportValues[i];
          if (pct === undefined) return;
          circle.style.strokeDashoffset = CIRC * (1 - pct / 100);
          if (reportSpans[i]) countUp(reportSpans[i], pct, 1500);
        });
      });
    }

    // Benefit side panel bars (animate widths on scroll)
    var BENEFIT_FILLS = [95, 85, 80, 75];
    var benefitBars = [];
    document.querySelectorAll('button[aria-controls^="benefit-panel-"]').length > 0 && (function () {
      var anyBtn = document.querySelector('button[aria-controls^="benefit-panel-"]');
      var col = anyBtn && anyBtn.parentElement;
      while (col && col.querySelectorAll('button[aria-controls^="benefit-panel-"]').length < 2) {
        col = col.parentElement;
      }
      if (!col) return;
      var grid = col.parentElement;
      if (!grid) return;
      Array.from(grid.children).forEach(function (child) {
        if (child !== col && child.querySelector && child.querySelector('ul')) {
          child.querySelectorAll('[class*="bg-electro-blue"][class*="h-full"]').forEach(function (bar) {
            benefitBars.push(bar);
          });
          observeOnce(child, 0.3, function () {
            benefitBars.forEach(function (bar, i) {
              if (BENEFIT_FILLS[i] !== undefined) bar.style.width = BENEFIT_FILLS[i] + '%';
            });
          });
        }
      });
    })();
  }

  /* ── 11. Commission calculator ───────────────────────────────────────── */
  function initCommissionCalc() {
    var ordersInput = document.getElementById('orders');
    var avgOrdInput = document.getElementById('avg-order');
    if (!ordersInput || !avgOrdInput) return;

    var tiers = [
      { minOrders: 1,  commission: 0.20 },
      { minOrders: 10, commission: 0.30 },
      { minOrders: 20, commission: 0.40 }
    ];

    function getTier(orders) {
      var t = tiers[0];
      tiers.forEach(function (tier) { if (orders >= tier.minOrders) t = tier; });
      return t;
    }
    function fmt(n) { return '$' + Math.round(n).toLocaleString(); }

    var animFrame = null;
    var displayedMonthly = 0;

    function animateTo(el, from, to, formatFn, dur) {
      if (animFrame) cancelAnimationFrame(animFrame);
      var start = performance.now();
      (function tick(now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 2);
        var val = from + (to - from) * eased;
        el.textContent = formatFn(val);
        if (p < 1) animFrame = requestAnimationFrame(tick);
        else el.textContent = formatFn(to);
      })(performance.now());
    }

    function update() {
      var orders = parseInt(ordersInput.value, 10) || 0;
      var avg    = parseInt(avgOrdInput.value, 10) || 0;
      var tier   = getTier(orders);
      var monthly = orders * avg * tier.commission;

      var allLabels = document.querySelectorAll('.font-display.italic.font-black.text-2xl');
      if (allLabels[0]) allLabels[0].textContent = orders;
      if (allLabels[1]) allLabels[1].textContent = '$' + avg;

      var headline = document.querySelector('.font-display.italic.font-black.text-5xl, .font-display.italic.font-black.text-6xl');
      if (headline) animateTo(headline, displayedMonthly, monthly, fmt, 350);
      displayedMonthly = monthly;

      var stats = document.querySelectorAll('.font-display.italic.font-black.text-xl');
      if (stats[0]) stats[0].textContent = orders > 0 ? fmt(orders * avg * tier.commission / orders) : '$0';
      if (stats[1]) stats[1].textContent = fmt(monthly / 4.33);
      if (stats[2]) stats[2].textContent = fmt(monthly * 12);
      if (stats[3]) stats[3].textContent = Math.round(tier.commission * 100) + '%';

      var caption = document.querySelector('p.text-sm');
      if (caption && caption.textContent.indexOf('orders per month') >= 0) {
        caption.textContent = 'at ' + orders + ' orders per month · ' +
          Math.round(tier.commission * 100) + '% commission · paid in USD';
      }

      var dots = document.querySelectorAll('.relative.flex.justify-between .w-4.h-4.rounded-full');
      dots.forEach(function (dot, i) {
        var active = orders >= tiers[i].minOrders;
        dot.style.background = active ? '#1A5FFF' : '#fff';
        dot.style.borderColor = active ? '#1A5FFF' : '#D1D5DB';
      });
    }

    ordersInput.addEventListener('input', update);
    avgOrdInput.addEventListener('input', update);
    update();
  }

  /* ── 12. Cart page (AJAX qty + remove) ──────────────────────────────── */
  function initCart() {
    var cartItems = document.getElementById('cart-items');
    if (!cartItems) return;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateCartSummary(cart) {
      var badge = document.querySelector('a[href="/cart"] span[aria-hidden="true"]');
      if (badge) badge.textContent = cart.item_count;

      var subtotalEl = document.getElementById('cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      var countLabel = document.getElementById('cart-item-count-label');
      if (countLabel) countLabel.textContent = '(' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');

      var wrap = document.getElementById('shipping-bar-wrap');
      if (wrap) {
        var threshold = parseInt(wrap.dataset.threshold, 10) || 3500;
        var remaining = threshold - cart.total_price;
        var textEl = document.getElementById('shipping-bar-text');
        var fillEl = document.getElementById('shipping-bar-fill');
        if (textEl) {
          if (remaining > 0) {
            textEl.className = 'text-xs text-gray-500 mb-1.5 font-body';
            textEl.innerHTML = 'Add <strong class="text-electro-ink">' + formatMoney(remaining) + '</strong> more for free shipping';
          } else {
            textEl.className = 'text-xs font-semibold text-electro-blue mb-1.5 font-body';
            textEl.textContent = "You've unlocked free shipping!";
          }
        }
        if (fillEl) {
          var pct = remaining > 0 ? Math.min(100, Math.round(cart.total_price * 100 / threshold)) : 100;
          fillEl.style.width = pct + '%';
        }
      }

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function changeCartItem(key, quantity, row, qtyDisplay) {
      var btns = row ? row.querySelectorAll('button') : [];
      btns.forEach(function (b) { b.disabled = true; });
      if (row) row.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            if (row) row.remove();
          } else {
            var item = null;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].key === key) { item = cart.items[i]; break; }
            }
            if (item) {
              if (qtyDisplay) qtyDisplay.textContent = item.quantity;
              var linePriceEl = document.querySelector('.cart-line-price[data-key="' + key + '"]');
              if (linePriceEl) linePriceEl.textContent = formatMoney(item.line_price);
            }
            btns.forEach(function (b) { b.disabled = false; });
            if (row) row.style.opacity = '1';
          }
          updateCartSummary(cart);
        })
        .catch(function () {
          btns.forEach(function (b) { b.disabled = false; });
          if (row) row.style.opacity = '1';
          window.location.reload();
        });
    }

    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-qty-btn');
      if (qtyBtn && cartItems.contains(qtyBtn)) {
        e.preventDefault();
        var key = qtyBtn.dataset.key;
        var row = document.querySelector('.cart-item[data-key="' + key + '"]');
        var qtyDisplay = row && row.querySelector('.cart-qty-display');
        var currentQty = qtyDisplay ? parseInt(qtyDisplay.textContent, 10) : 1;
        var newQty = Math.max(0, currentQty + parseInt(qtyBtn.dataset.delta, 10));
        changeCartItem(key, newQty, row, qtyDisplay);
        return;
      }

      var removeBtn = e.target.closest('.cart-remove');
      if (removeBtn && cartItems.contains(removeBtn)) {
        e.preventDefault();
        var key = removeBtn.dataset.key;
        var row = document.querySelector('.cart-item[data-key="' + key + '"]');
        changeCartItem(key, 0, row, null);
      }
    });
  }

  /* ── 13. Buy Now — clear cart then add qty 1 to avoid stacking ──────── */
  function initBuyNow() {
    var forms = document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(function (form) {
      if (!form.querySelector('input[name="return_to"]')) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var idInput = form.querySelector('input[name="id"]');
        var planInput = form.querySelector('input[name="selling_plan"]');
        var variantId = idInput ? parseInt(idInput.value, 10) : 0;
        var planId = (planInput && !planInput.disabled && planInput.value) ? parseInt(planInput.value, 10) : null;

        if (!variantId) { form.submit(); return; }

        var btn = form.querySelector('button[type="submit"]');
        var origHtml = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        var addBody = { id: variantId, quantity: 1 };
        if (planId) addBody.selling_plan = planId;

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addBody)
            });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = origHtml; }
            form.submit();
          });
      });
    });
  }

  /* ── 14. Shop page image gallery ─────────────────────────────────────── */
  function initImageGallery() {
    var thumbBtns = document.querySelectorAll('button[aria-label^="View product image"]');
    if (!thumbBtns.length) return;
    var mainImg = document.querySelector('.relative.aspect-square.rounded-2xl img');
    if (!mainImg) return;
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var thumb = btn.querySelector('img');
        if (thumb) mainImg.src = thumb.src;
        thumbBtns.forEach(function (b) {
          b.classList.remove('border-electro-orange');
          b.classList.add('border-transparent');
        });
        btn.classList.add('border-electro-orange');
        btn.classList.remove('border-transparent');
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────────────────── */
  function init() {
    initMobileMenu();
    initCommissionCalc();
    initImageGallery();
    initMarquee();
    initCountUp();
    initCart();
    initBuyNow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
